import { IST_TIMEZONE, getISTTimeParts } from "./timetableTimeSlots";

const DAY_MAP = {
  SUNDAY: 0,
  MONDAY: 1,
  TUESDAY: 2,
  WEDNESDAY: 3,
  THURSDAY: 4,
  FRIDAY: 5,
  SATURDAY: 6,
};

function getISTDayIndex(now = new Date()) {
  const weekday = new Intl.DateTimeFormat("en-US", {
    timeZone: IST_TIMEZONE,
    weekday: "short",
  }).format(now instanceof Date ? now : new Date(now));
  const map = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
  return map[weekday] ?? new Date(now).getDay();
}

function parseSlotMinutes(timeVal) {
  const raw = String(timeVal || "").trim().slice(0, 5);
  const [h, m] = raw.split(":").map((x) => Number.parseInt(x, 10));
  if (!Number.isFinite(h) || !Number.isFinite(m)) return null;
  return h * 60 + m;
}

/**
 * Occurrence status for this week's weekly timetable slot (IST wall clock).
 * - UPCOMING: not started yet this week
 * - IN_PROGRESS: today's occurrence, between start and end
 * - PAST: earlier day this week, or today after end time
 */
export function getTimetableSlotOccurrenceStatus(slot, now = new Date()) {
  if (!slot) return "UPCOMING";
  const day = String(slot.dayOfWeek || slot.day || "").toUpperCase();
  const slotDay = DAY_MAP[day];
  if (slotDay === undefined) return "UPCOMING";

  const today = getISTDayIndex(now);
  if (slotDay < today) return "PAST";
  if (slotDay > today) return "UPCOMING";

  const startMins = parseSlotMinutes(slot.startTime);
  const endMins = parseSlotMinutes(slot.endTime);
  if (startMins == null) return "UPCOMING";

  const nowMins = getISTTimeParts(now).minutesOfDay;
  if (nowMins < startMins) return "UPCOMING";
  // Inclusive end: Start <= now <= End → In Progress; only after end → Completed.
  if (endMins != null && Number.isFinite(endMins) && nowMins > endMins) return "PAST";
  return "IN_PROGRESS";
}

/** True only while this week's occurrence is currently in progress — used to lock edits. */
export function isTimetableSlotStarted(slot, now = new Date()) {
  return getTimetableSlotOccurrenceStatus(slot, now) === "IN_PROGRESS";
}

export function timetableSlotOccurrenceLabel(status) {
  switch (String(status || "").toUpperCase()) {
    case "UPCOMING":
      return "Upcoming";
    case "IN_PROGRESS":
      return "In progress";
    case "PAST":
      return "Completed";
    default:
      return null;
  }
}

export function timetableSlotStartedMessage() {
  return "This lecture is currently in progress and cannot be modified.";
}
